
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

interface BottomNavItemProps {
    to?: string;
    icon: any;
    label: string;
    onClick?: () => void;
    isActive?: boolean;
}

export const BottomNavItem: React.FC<BottomNavItemProps> = ({ to, icon: Icon, label, onClick, isActive }) => {
  const itemRef = useRef<any>(null);

  useEffect(() => {
    if (isActive && itemRef.current) {
      itemRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, [isActive]);

  // Icon-only styling with centered alignment and active state indication
  const baseClass = `flex flex-col items-center justify-center w-full h-full transition-all duration-200 ${
    isActive 
      ? 'text-white scale-110' 
      : 'text-neutral-500 hover:text-neutral-300'
  }`;

  const content = (
    <>
      <Icon size={24} className={isActive ? 'drop-shadow-[0_0_10px_rgba(255,255,255,0.4)]' : ''} />
      {/* Visual active indicator dot instead of text */}
      {isActive && <div className="w-1 h-1 bg-white rounded-full mt-1"></div>}
    </>
  );

  if (to) {
    return (
      <Link ref={itemRef} to={to} className={baseClass} onClick={onClick} aria-label={label}>
        {content}
      </Link>
    );
  }

  return (
    <button ref={itemRef} onClick={onClick} className={baseClass} aria-label={label}>
      {content}
    </button>
  );
};
